/* Factumis App — icônes (style Phosphor, trait 1.5, currentColor). */

// Chaque entrée = contenu interne d'un <svg viewBox="0 0 24 24">.
export const FxIcons = {
  // nav
  grid: '<rect x="4" y="4" width="7" height="7" rx="1.6"/><rect x="13" y="4" width="7" height="7" rx="1.6"/><rect x="4" y="13" width="7" height="7" rx="1.6"/><rect x="13" y="13" width="7" height="7" rx="1.6"/>',
  'file-out': '<path d="M13 3H6v18h12V8z"/><path d="M13 3v5h5"/><path d="M12 18v-6"/><path d="M9.5 14.5L12 12l2.5 2.5"/>',
  'file-in': '<path d="M13 3H6v18h12V8z"/><path d="M13 3v5h5"/><path d="M12 12v6"/><path d="M9.5 15.5L12 18l2.5-2.5"/>',
  quote: '<path d="M13 3H6v18h12V8z"/><path d="M13 3v5h5"/><path d="M9 13h6M9 16.5h4"/>',
  users: '<circle cx="9" cy="8" r="3.2"/><path d="M3.5 19a5.5 5.5 0 0 1 11 0"/><path d="M16 5.2a3.2 3.2 0 0 1 0 5.6"/>',
  truck: '<path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/>',
  report: '<path d="M5 4h14v16H5z"/><path d="M9 14v3M12 11v6M15 9v8"/>',
  bar: '<path d="M4 20h16"/><path d="M7 20v-6M12 20V8M17 20v-9"/>',
  shield: '<path d="M12 3l7 2.5v5.5c0 4.5-3.2 7.4-7 8.5-3.8-1.1-7-4-7-8.5V5.5z"/><path d="M9 11.5l2 2 4-4"/>',
  building: '<path d="M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16"/><path d="M15 9h3a1 1 0 0 1 1 1v11"/><path d="M3 21h18"/><path d="M8 7h3M8 11h3M8 15h3"/>',
  gear: '<circle cx="12" cy="12" r="3.2"/><path d="M12 3v2.5M12 18.5V21M21 12h-2.5M5.5 12H3M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8M18.4 18.4l-1.8-1.8M7.4 7.4L5.6 5.6"/>',
  team: '<circle cx="12" cy="7.5" r="3"/><path d="M6 20a6 6 0 0 1 12 0"/><circle cx="4.5" cy="10" r="1.8"/><circle cx="19.5" cy="10" r="1.8"/>',
  card: '<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M3 9.5h18M6.5 14.5h4"/>',
  help: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.4 2.4 0 1 1 3.4 2.2c-.8.4-1 .9-1 1.6"/><circle cx="12" cy="16.4" r="1" fill="currentColor" stroke="none"/>',
  // actions / ui
  bell: '<path d="M7 9a5 5 0 0 1 10 0c0 5 2 6 2 6H5s2-1 2-6z"/><path d="M10 20a2 2 0 0 0 4 0"/>',
  search: '<circle cx="11" cy="11" r="6"/><path d="M20 20l-4-4"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
  'check-c': '<circle cx="12" cy="12" r="9"/><path d="M8 12.2l2.6 2.6L16 9.4"/>',
  x: '<path d="M6 6l12 12M18 6L6 18"/>',
  'x-c': '<circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="7.8" r="1" fill="currentColor" stroke="none"/>',
  alert: '<path d="M12 3.5l9 16H3z"/><path d="M12 9.5v4.5"/><circle cx="12" cy="17" r="1" fill="currentColor" stroke="none"/>',
  'chev-l': '<path d="M14 6l-6 6 6 6"/>',
  'chev-r': '<path d="M10 6l6 6-6 6"/>',
  'chev-d': '<path d="M6 9l6 6 6-6"/>',
  'chev-u': '<path d="M6 15l6-6 6 6"/>',
  'arrow-r': '<path d="M4 12h15M13 6l6 6-6 6"/>',
  'arrow-l': '<path d="M20 12H5M11 6l-6 6 6 6"/>',
  download: '<path d="M12 3v12M8 11l4 4 4-4"/><path d="M5 20h14"/>',
  send: '<path d="M21 4L3 11l7 2.5L13 21l8-17z"/><path d="M10 13.5L21 4"/>',
  copy: '<rect x="8" y="8" width="12" height="12" rx="2.2"/><path d="M16 8V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
  edit: '<path d="M5 19l-1 1 1-4L16 5l3 3L8 19z"/><path d="M14 7l3 3"/>',
  trash: '<path d="M5 7h14M9 7V5h6v2M7 7l1 13h8l1-13"/>',
  more: '<circle cx="6" cy="12" r="1.4" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none"/><circle cx="18" cy="12" r="1.4" fill="currentColor" stroke="none"/>',
  filter: '<path d="M4 5h16l-6 7v6l-4 2v-8z"/>',
  sort: '<path d="M8 9l4-4 4 4M8 15l4 4 4-4"/>',
  clock: '<circle cx="12" cy="12" r="8"/><path d="M12 7.5V12l3 2"/>',
  euro: '<path d="M16.5 7.5A6 6 0 1 0 16.5 16.5"/><path d="M5 10.5h7M5 13.5h7"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12h2.5M19 12h2.5M5 5l1.8 1.8M17.2 17.2L19 19M19 5l-1.8 1.8M6.8 17.2L5 19"/>',
  moon: '<path d="M20 13.5A8 8 0 1 1 10.5 4a6.5 6.5 0 0 0 9.5 9.5z"/>',
  // demi-cercle plein : thème « système » (suit prefers-color-scheme)
  contrast: '<circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" stroke="none"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  logout: '<path d="M14 5h4a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-4"/><path d="M9 12h11M16 8l4 4-4 4"/>',
  user: '<circle cx="12" cy="8" r="3.4"/><path d="M5.5 19a6.5 6.5 0 0 1 13 0"/>',
  'arrow-up': '<path d="M12 19V6M6 12l6-6 6 6"/>',
  'arrow-down': '<path d="M12 5v13M6 12l6 6 6-6"/>',
  sidebar: '<rect x="3" y="4" width="18" height="16" rx="2.5"/><path d="M9 4v16"/>',
  sparkle: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/>',
  upload: '<path d="M12 16V4M8 8l4-4 4 4"/><path d="M5 20h14"/>',
  receipt: '<path d="M6 3h12v18l-3-2-3 2-3-2-3 2z"/><path d="M9 8h6M9 12h6"/>',
  // Étiquette de prix : catalogue d'articles et prestations (distincte de `receipt`,
  // réservée aux cotisations).
  tag: '<path d="M11 3H4v7l10 10 7-7L11 3z"/><circle cx="7.6" cy="7.6" r="1.4"/>',
  link: '<path d="M9 15l6-6"/><path d="M11 7l1-1a3.5 3.5 0 0 1 5 5l-1 1"/><path d="M13 17l-1 1a3.5 3.5 0 0 1-5-5l1-1"/>',
  phone: '<path d="M6 4h3l1.5 4-2 1.5a11 11 0 0 0 5 5L15 12l4 1.5V17a2 2 0 0 1-2 2A14 14 0 0 1 4 6a2 2 0 0 1 2-2z"/>',
  pin: '<path d="M12 21s7-5.5 7-11a7 7 0 0 0-14 0c0 5.5 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
} as const;

export type IconName = keyof typeof FxIcons;

export function fxSvg(name: IconName | string, w = 24): string {
  const body = (FxIcons as Record<string, string>)[name] || '';
  return (
    `<svg viewBox="0 0 24 24" width="${w}" height="${w}" fill="none" stroke="currentColor" ` +
    `stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`
  );
}

export function Icon({ name, size = 24 }: { name: IconName | string; size?: number }) {
  return (
    <span
      style={{ display: 'inline-flex', lineHeight: 0 }}
      dangerouslySetInnerHTML={{ __html: fxSvg(name, size) }}
    />
  );
}
